"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_UNTIL_IDLE = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const useEventListener_1 = __importDefault(require("../../../common/helpers/Hooks/useEventListener"));
exports.TIME_UNTIL_IDLE = 120 * 1000;
const KioskIdleTimer = (props) => {
    const { history, baseUrl } = props;
    const idleTimer = (0, react_1.useRef)(null);
    const returnToKioskHomepage = () => {
        history.push({
            pathname: `${baseUrl}/guest_journey/kiosk`,
        });
    };
    const resetTimer = () => {
        if (idleTimer.current) {
            clearTimeout(idleTimer.current);
        }
        const urlEnableIdleTimer = window.location.search.includes('stopIdleTimer=false');
        const urlDisableIdleTimer = window.location.search.includes('stopIdleTimer=true');
        if (urlEnableIdleTimer) {
            localStorage.setItem('idleTimerStopped', 'false');
        }
        if (urlDisableIdleTimer) {
            localStorage.setItem('idleTimerStopped', 'true');
        }
        const storageIdleTimerStopped = localStorage.getItem('idleTimerStopped');
        const idleTimerIsStopped = storageIdleTimerStopped === 'true';
        if (idleTimerIsStopped) {
            return;
        }
        idleTimer.current = setTimeout(() => {
            returnToKioskHomepage();
        }, exports.TIME_UNTIL_IDLE);
    };
    (0, useEventListener_1.default)('startKioskIdleTimer', resetTimer);
    (0, useEventListener_1.default)('touchstart', resetTimer);
    (0, useEventListener_1.default)('click', resetTimer);
    (0, react_1.useEffect)(() => () => {
        clearTimeout(idleTimer.current);
    }, []);
    return '';
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(KioskIdleTimer));
